import React from 'react';
import { ITagData } from '../../../types/tags/ITagData';
import { DataGrid, NavigationItem } from '../../../ui-toolkit';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { BodyTextTW } from '../../../tailwindComponents/bodyText/BodyTextTW';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { upperFirst } from 'lodash';

export interface ITagsTableProps {
  data: ITagData[];
}

const columns: IBootstrapTableColumnProps<ITagData>[] = [
  {
    dataField: 'label',
    headerStyle: { width: '160px' },
    text: 'Tag Name',
  },
  {
    dataField: 'type',
    headerStyle: { width: '120px' },
    formatter: (column, row) => {
      return <BodyTextTW>{upperFirst(row.type)}</BodyTextTW>;
    },
    text: 'Type',
  },
  {
    dataField: 'isActive',
    headerStyle: { width: '120px' },
    formatter: (column, row) => {
      return <BodyTextTW>{row.isActive ? 'Active' : 'Deactivated'}</BodyTextTW>;
    },
    text: 'Is Active',
  },
  {
    dataField: '',
    headerStyle: { width: '10px' },
    formatter: (column, row) => {
      return (
        <NavigationItem to={clientUrls.urlFor.administrationEditTag(row.id)} text={'Edit'}>
          <FontAwesomeIcon icon={faEdit} />
        </NavigationItem>
      );
    },
    text: '',
  },
];

export const TagsTable: React.FC<ITagsTableProps> = ({ data }) => {
  return <DataGrid columns={columns} data={data} keyField="id" remote />;
};
